import type { Ref } from 'react'

/** Assign a node to a callback or object ref (an input's own ref plus the caller's). */
export function assignRef<T>(ref: Ref<T> | undefined, node: T | null) {
  if (typeof ref === 'function') ref(node)
  else if (ref) ref.current = node
}
